import React from 'react';
import {
    calcTransferPrice, calcTransferPriceShort,
    currencySymbol,
    estimateTransferTime,
    getMediaURL,
    price, truncate
} from "../../../../../config/values";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {Card, CardContent, Chip, Typography} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import {Link} from "react-router-dom";
import {
    BadgePercent,
    Bike,
    DollarSign,
    Home,
    Hourglass,
    PackageCheck,
    PiggyBank,
    Sparkles,
    Star,
    Utensils
} from "lucide-react";
import {useTranslation} from "react-i18next";
import WishListButton from "./WishListButton";
import clsx from "clsx";
import Courier from "../../../../components/icons/Courier";
import Lira from "../../../../components/icons/Lira";

function VendorSliderItem({vendor,classes,wishlist,industry}) {
    const { t } = useTranslation();

    let category = !!vendor.categories ? vendor.categories[0] : null;
    return (
        <Card component={Link} to={`/vendor/${vendor.slug}`} className={clsx(classes.vendorSliderItem,(vendor.not_in_radius == 1 || !vendor.is_open) && "not_in_radius")}>
            <CardMedia image={getMediaURL(vendor.banner,"s_thumb")} className="card-media">
                <img loading="lazy" className="logo" src={getMediaURL(vendor.logo)} alt={vendor.name}/>
                <div className="wish-holder">
                    <WishListButton id={vendor.id} is_icon/>
                </div>
            </CardMedia>
            <div className="chips-holder">
                {
                    !!vendor.is_popular &&
                    <Chip
                        icon={<Sparkles className="lucide-small"/>}
                        label={t('popular')}
                        color="secondary"
                        variant="contained"
                        className="vendor-type-chip"
                    />
                }
                {
                    !!vendor.is_economic &&
                    <Chip
                        icon={<BadgePercent className="lucide-small"/>}
                        label={t('economic')}
                        color="secondary"
                        variant="contained"
                        className="vendor-type-chip"
                    />
                }
                {/*{
                    !!vendor.is_pod &&
                    <Chip
                        icon={<PackageCheck className="lucide-small" />}
                        label={t('pod')}
                        color="secondary"
                        variant="contained"
                        className="vendor-type-chip"
                    />
                }*/}
            </div>
            <CardContent className="card-content">
                <span className='rating-holder'><Star className="rating-icon"/> {vendor.average_rate}</span>
                <Link className="vendor-title" to={`/vendor/${vendor.slug}`} >{vendor.name}</Link>
                {
                    !wishlist &&
                    <>
                        <div className="infobar">
                            <span className='category'><Utensils className="lucide-smaller lucide-icon-gray"/> <Link to={`/${industry}/discover?categories=${category?.id}`} >{truncate(category?.name , 10)}</Link></span>
                            {
                                !!vendor.preparation_time &&
                                <span className='delivery'><Hourglass  className="lucide-smaller lucide-icon-gray"/> {estimateTransferTime(vendor)} </span>
                            }
                            <span className={`delivery-price ${(!!vendor.has_free_delivery && !vendor.free_delivery_limit) ? "free" : 'not-free'}`}><Courier className="not-lucide"/> {calcTransferPriceShort(vendor)} </span>
                        </div>
                        <div className="infobar">
                            <span className={`min-order`}><Lira className="not-lucide"/> {!!vendor.minimum_order ? price(vendor.minimum_order)+ currencySymbol : t('no')} {t('minimum')}</span>
                        </div>
                    </>
                }
            </CardContent>
        </Card>
    );
}

export default withStyles(Styles)(VendorSliderItem);
